import { createContext } from 'react';

export type RatingHoverContextValue = {
  hoveredValue: string | null;
  setHoveredValue: (value: string | null) => void;
};

export const RatingHoverContext = createContext<RatingHoverContextValue>({
  hoveredValue: null,
  setHoveredValue: () => {},
});
